import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { createProvider, Step } from '../../../../shared/IFE/step/step/step';
import { ChargingStationPlacement } from '../../../../shared/modules/evc-api/models/constants';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';

@Component({
  selector: 'app-charging-station-placement',
  providers: [createProvider(ChargingStationPlacementComponent)],
  templateUrl: './charging-station-placement.component.html',
  styleUrls: ['./charging-station-placement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChargingStationPlacementComponent extends Step implements OnInit {
  readonly chargingStationPlacement = ChargingStationPlacement;

  readonly formName = 'evcSimulator';
  readonly stepName = 'charging-station-placement';

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  writeValue(value) {
    super.writeValue({ placement: value });
  }

  protected valueChanges(values) {
    super.valueChanges(values.placement);
  }

  protected buildForm(): void {
    this.control = this.fb.group({
      placement: this.fb.control('', [Validators.required]),
    });
    this.subscribeToValueChanges();
  }
}
